<template>
    <div class="hero">
      <div class="hero-body is-full">
      <div class="hero-body container container box has-background-white-bis">
        <form class="has-text-centered" data-vv-scope="step1">
          <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
          <section class="has-text-left">
            <div class="notification has-background-grey-dark has-text-white">
              Please update vehicle washing status.
            </div>
            <div class="is-full">
              <div class="columns is-multiline">
                <div class="column is-12">
                  <div class="field" v-if="currentRoService && currentRoService.roServiceVehicle">
                    <span class="is-inline-block" style="font-weight:bold;" v-html="makeOverview(currentRoService.roServiceVehicle)"></span>
                  </div>
                  <div class="field" v-if="currentRoService && !currentRoService.roServiceVehicle">
                    <span class="is-inline-block" style="font-weight:bold;">Vehicle details not available</span>
                  </div>
                </div>
                <div class="column is-12">
                  <multiselect
                    :multiple="false"
                    name="washingStatus"
                    v-validate="{ 'required': true }"
                    :class="{ 'is-danger': errors.has('washingStatus') }"
                    data-vv-as="washing status"
                    placeholder="Select Washing Status"
                    label="name"
                    track-by="id"
                    :options="definedTypes.valetWashingStatus.options"
                    :searchable="true"
                    v-model="selectedWashingStatus">
                  </multiselect>
                </div>
                <div class="box column is-12" v-if="currentRoService && currentRoService.washingStatusHistoryItems && currentRoService.washingStatusHistoryItems.length > 0">
                  <div class="column is-narrow" style="padding-right:0">
                    <span class="is-6 is-inline-block" style="font-weight:bold; font-size: 1.125rem;">Washing Status History</span>
                  </div>
                  <br />
                  <table class="table is-bordered is-narrow is-hoverable is-fullwidth">
                    <thead>
                      <tr>
                        <th>To Status</th>
                        <th>Actioned By</th>
                        <th>Actioned On</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="washingStatusHistoryItem in currentRoService.washingStatusHistoryItems" :key="washingStatusHistoryItem.id">
                        <td>{{ getStatusDescription(washingStatusHistoryItem.newWashingStatus)}}</td>
                        <td>{{ washingStatusHistoryItem.actionedBy}}</td>
                        <td>{{ washingStatusHistoryItem.createdAt | formatDate }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </form>
        <br>
        <div>
          <button class="button" @click="validateBeforeSubmit" :disabled="!statusValueChanged"> Save</button>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import _ from 'lodash'
import utilitiesMixin from '@/mixins/generic/utilities'
import roServiceService from '@/services/roServiceService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'

const mapConfigGetters = createNamespacedHelpers('config').mapGetters
export default {
  name: 'VehicleWashingStatusUpdate',
  components: {
    'error-display-component': ErrorDisplayComponent
  },
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  mixins: [validateBeforeSubmitMixin, utilitiesMixin],
  data () {
    return {
      isLoading: false,
      selectedWashingStatus: null,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      isValidToken: false,
      currentUser: null,
      currentRoService: null,
      initialWashingStatus: null,
      latestWashingNote: ''
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    valetWashingStatusOptions: function () {
      return this.definedTypes.valetWashingStatus.options
    },
    statusValueChanged: function () {
      if (!this.initialWashingStatus && !this.selectedWashingStatus) {
        return false
      } else if (this.initialWashingStatus && this.selectedWashingStatus && this.initialWashingStatus.name === this.selectedWashingStatus.name) {
        return false
      } else if (!this.initialWashingStatus && this.selectedWashingStatus) {
        return true
      } else if (this.initialWashingStatus && !this.selectedWashingStatus) {
        return true
      } else if (this.initialWashingStatus && this.selectedWashingStatus && this.initialWashingStatus.name !== this.selectedWashingStatus.name) {
        return true
      }
      const comparison = _.isEqual(this.selectedWashingStatus, this.initialWashingStatus)
      return !comparison
    },
    latestNote: function () {
      if (this.latestWashingNote.length > 0) {
        return this.latestWashingNote
      }
      return ''
    }
  },
  created () {
    this.$emit('is-home', false)
  },
  mounted () {
    this.fetchIdentityVerification(this.token)
    this.$emit('set-title-one', 'WASHING')
    this.$emit('set-title-two', 'STATUS')
  },
  methods: {
    fetchIdentityVerification: function (currentToken) {
      const that = this
      this.currentRoService = null
      this.currentUser = null
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      roServiceService.getRoServiceInformation(currentToken).then(response => {
        that.currentUser = {
          ...response.data.userData
        }
        that.currentRoService = {
          ...response.data.roService
        }
        const washingNotes = that.currentRoService.notes.filter(function (el) {
          return el.note.includes('Vehicle washing status')
        })
        if (washingNotes.length > 0) {
          that.latestWashingNote = washingNotes[0].note
        }
        that.dealerId = that.currentRoService.roServiceCustomer.dealerId
        if (!that.dealerId || that.dealerId === 0) {
          that.serverErrorMessage = 'Could not load R.O. service vehicle washing status information with token: ' + currentToken
        } else {
          that.isValidToken = true
          that.isLoading = false
          that.initInputValues()
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        that.isLoading = false
        that.serverErrorMessage = 'Could not load R.O. service vehicle washing status information  with token: ' + currentToken
        that.isValidToken = false
      })
    },
    initInputValues: function () {
      this.selectedWashingStatus = this.currentRoService.washingStatus ? this.definedTypes.valetWashingStatus.options.find(x => x.altName === this.currentRoService.washingStatus) : null
      this.initialWashingStatus = this.selectedWashingStatus
    },
    makeOverview: function (inventory) {
      if (!inventory) {
        return ''
      }
      var result = ''
      result = inventory.vin
      result += '<br /> ' + inventory.name
      if (inventory.color) {
        result += '<br /> Ext. Color (' + inventory.color + ')'
      }
      return result
    },
    onSave: function () {
      const that = this
      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []
      const updateWashingStatusModel = {
        token: this.token,
        roServiceId: this.currentRoService.id,
        washingStatus: this.selectedWashingStatus.altName,
        userId: this.currentUser.id
      }

      roServiceService.updateServiceVehicleWashingStatus(updateWashingStatusModel).then(response => {
        that.isSaving = false
        if (response.errors) {
          that.serverErrors = response.errors
          that.$nextTick(function () {
            var elmnt = document.getElementById('main-page')
            elmnt.scrollTo(0, 0)
          })
        } else {
          that.onChangesSaved()
          that.onComplete()
        }
      }).catch((error) => {
        that.serverErrorMessage = error.message
        that.isSaving = false
        that.$nextTick(function () {
          var elmnt = document.getElementById('main-page')
          elmnt.scrollTo(0, 0)
        })
      })
    },
    onComplete () {
      this.fetchIdentityVerification(this.token)
    },
    getStatusDescription: function (washingStatus) {
      const result = washingStatus ? this.valetWashingStatusOptions.find(x => x.altName === washingStatus) : null
      if (result) {
        return result.name
      }
      return washingStatus
    }
  },
  watch: {
    token: function (newValue, oldValue) {
      this.isValidToken = false
      this.fetchIdentityVerification(this.token)
    }
  }
}
</script>
